import { post } from './common'
type ApiBaseResult = ApiTypes.ApiBaseResult

export namespace sidePanel {
  // 划词翻译接口
  export function scribeTranslate(
    params: PostDataTypes.ScribeTranslateOptions
  ): Promise<ApiBaseResult & { data: ServerDataTypes.ScribeTranslateResult }> {
    return post('/scribe/translate_v2', {}, { ...params, isDecr: true })
  }

  export function textTranslate(params: {
    text: string
    fromLang: string
    toLang: string
    translateModel: string
    context?: string
    useType?: PostDataTypes.UseType | 'compare' | 'select_compare'
    pageUrl?: string
    pageTitle?: string
  }): Promise<
    ApiBaseResult & {
      content: string
      taskId: number
    }
  > {
    return post('/online/translate', {}, params)
  }
}
